import { formatAsUriParameters, get } from '@namespace/helpers';
import { IGame, PlatformType } from '../../../types';

interface IGetGamesListParams {
  userSegments: string[];
  platform: PlatformType;
  gamesIds: (number | string)[];
}

export const getGamesList = ({
  userSegments,
  platform,
  gamesIds
}: IGetGamesListParams): Promise<IGame[]> =>
  get(
    `/adm-gw01/public/games?${formatAsUriParameters(
      {
        games: gamesIds,
        userSegments,
        platform
      },
      true
    )}`
  );
